module.exports = __webpack_public_path__ + "static/img/device.4f6ba815.png";